<template>
<v-container>
  
  
  <v-dialog
    v-model="loading"
    hide-overlay
    persistent
    width="300"
    >
    <v-card
      color="red"
      dark
      >
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
  
  
  
  
  
        <v-card dark color="amber darken-4" class="elevation-10">
          <v-card-text>
            <span class="display-1 font-weight-medium">Monthly products report</span>
            <br/>

            <v-overflow-btn
              v-model="kind"
              class="my-2"
              :items="kinds"
              label="Select product type"
              target="#dropdown-example"
              color="amber darken-4"
              ></v-overflow-btn>
          </v-card-text>
        </v-card>
  
  
  <v-layout>
    <v-row>
      <v-col
	cols="3"
	v-for="report in reports"
	:key="report.name"
	>
	<v-container>
	  <v-card>
	    <v-card-title>{{ report.name }}</v-card-title>
	    <br/>
	  <v-card-text>
	    <v-gauge :value="report.percent" height="150" :minValue="minValue" :maxValue="maxValue" :options="gaugeOpts"/>
	  </v-card-text>
	  </v-card>
	</v-container>
      </v-col>
    </v-row>
  </v-layout>
  
  
  
</v-container>
</template>

<script>
import { CalendarHeatmap } from 'vue-calendar-heatmap';
import VGauge from "vgauge";

import { config } from '../config';


export default {
    components: {
        CalendarHeatmap,
	VGauge,
    },
    
    props: {
	wantedreportdate: String
    },
    
    data: () => ({
	kinds: [
	    'ana',
	    '00Z.*j0', '00Z.*j1', '00Z.*j2', 
	    '00Z.*j3', '00Z.*j4', '00Z.*j5', 
	    '00Z.*j6', '00Z.*j7', '00Z.*j8', 
	    '00Z.*j9', '12Z.*j0', '12Z.*j1', 
	    '12Z.*j2', '12Z.*j3', '12Z.*j4', 
	    '12Z.*j5', '12Z.*j6', '12Z.*j7', 
	    '12Z.*j8', '12Z.*j9', 'other',
	],
	kind: 'ana',
        loading: true,
	errorState: false,
	booltrue: true,
        reports: {},
	reportsRaw: {},
	minValue: 0,
	maxValue: 100,
	gaugeOpts: {
	    angle: -0.26,
	    lineWidth: 0.1,
	    colorStart: '#303030',
	    colorStop: '#303030',
	    background: '#303030',
	    strokeColor: '#303030',
	    percentColors: [[0.0, "#F44336" ], [0.60, "#FF9800"], [0.90, "#FFEB3B"], [1.0, "#4CAF50"]],
	    pointer: {
		length: 0.42,
		strokeWidth: 0.064,
		color: '#000000'
	    },
	    renderTicks: {
		divisions: 10,
		divWidth: 1.1,
		divLength: 1,
		divColor: '#333333',
		subDivisions: 3,
		subLength: 0.5,
		subWidth: 0.6,
		subColor: '#666666'
	    },
	    staticLabels: {
		font: "15px sans-serif",  // Specifies font
		labels: [10, 20, 30, 40, 50, 60, 70, 80, 90],  // Print labels at these values
		color: "#FFF",  // Optional: Label text color
		fractionDigits: 0  // Optional: Numerical precision. 0=round off.
	    },

	},
    }),
    
    created() {
	this.loadSummData();
    },
    
    watch: {
	kind() {
	    this.filterData();
	},
    },
    
    computed: {
    },
    
    methods: {
	loadSummData() {
	    this.loading = true;
            const urlSumm = `${config.baseUrl}deliveries/products/report`;
	    
            this.$http.get(urlSumm, { auth: this.$store.getters.auth }).then((res) => {
                this.reportsRaw = res.data;
		this.filterData();
                this.loading = false;
            }).catch((err) => {
                console.log(err);
            });
	},

	filterData() {
	    
	    if (this.kind !== 'other') {
		this.reports = this.reportsRaw.filter(r => (new RegExp(this.kind)).test(r.name));
	    } else {
		this.reports = this.reportsRaw;
		this.kinds.forEach(k => {
		    this.reports = this.reports.filter(r => !(new RegExp(k)).test(r.name));
		});
	    }
	},
    },
};
</script>

<style lang="scss" scoped>
canvas {
    background-color: red;
    height: 100px !important;
}
</style>
